export default "__VITE_ASSET__QKO58j2g__"